(() => {
  if (window.__pinkpomeShadeFixV2) return;
  window.__pinkpomeShadeFixV2 = true;
  const base = window.Shopify?.routes?.root || "/";
  const products = new Map();
  let busy = false;
  const plan = x => x.selling_plan_allocation?.selling_plan?.id || null;
  const bundle = x => {
    try { return JSON.parse(x.properties?.__kaching_bundles || "null"); }
    catch { return null; }
  };
  const input = x => ({
    id: x.variant_id, quantity: x.quantity, properties: {...(x.properties || {})},
    ...(plan(x) ? {selling_plan: plan(x)} : {})
  });
  async function request(path, body) {
    const response = await fetch(base + path + (body ? "?kaching_bundles=true" : ""), {
      credentials: "same-origin", cache: "no-store",
      ...(body ? {method:"POST",headers:{"Content-Type":"application/json","X-Kaching-Cart-Ignore":"1"},body:JSON.stringify(body)} : {})
    });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || "Unable to update shade.");
    return data;
  }
  const signature = x => JSON.stringify([
    Number(x.variant_id || x.id), Number(plan(x) || x.selling_plan || 0),
    Object.entries(x.properties || {}).sort(([a],[b]) => a.localeCompare(b))
  ]);
  function totals(items) {
    const map = new Map();
    for (const item of items) map.set(signature(item), (map.get(signature(item)) || 0) + item.quantity);
    return map;
  }
  function equal(a,b) {
    const x=totals(a), y=totals(b);
    return x.size===y.size && [...x].every(([k,v])=>y.get(k)===v);
  }
  function notice(text) {
    document.getElementById("pinkpome-shade-message")?.remove();
    if (!text) return;
    const message=document.createElement("p");
    message.id="pinkpome-shade-message";
    message.setAttribute("role","alert");
    message.textContent=text;
    message.style.cssText="padding:12px;margin:12px;color:#861b38;background:#fff;border:1px solid #861b38;border-radius:8px";
    document.querySelector(".kazam-drawer .kazam-content")?.prepend(message);
  }
  function lock(event) {
    if (busy && event.target.closest?.(".kazam-drawer")) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }
  document.addEventListener("click",lock,true);
  document.addEventListener("change",lock,true);
  function install() {
    const drawer=window.KazamCart;
    if (!drawer || typeof drawer.renderProduct!=="function" || typeof drawer.refresh!=="function") return false;
    const render=drawer.renderProduct;
    drawer.renderProduct=function(item) {
      const row=render.call(this,item);
      row.addEventListener("change",async event=>{
        const select=event.target.closest?.(".kazam-variant-select");
        if (!select) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (busy) return;
        busy=true;
        notice("");
        const controls=[...document.querySelectorAll(".kazam-drawer select,.kazam-drawer button,.kazam-drawer input")];
        const disabled=controls.map(x=>x.disabled);
        controls.forEach(x=>x.disabled=true);
        let failure="";
        let originalGroup=null;
        let remaining=null;
        let expected=null;
        try {
          const cart=await request("cart.js");
          const old=cart.items.find(x=>x.key===item.key);
          if (!old) throw new Error("Your cart changed. Please choose the shade again.");
          if (!products.has(old.handle)) products.set(old.handle,await request("products/"+encodeURIComponent(old.handle)+".js"));
          const options=[...row.querySelectorAll(".kazam-variant-select")].map(x=>x.value);
          const target=products.get(old.handle).variants.find(x=>x.options.length===options.length && x.options.every((v,i)=>v===options[i]));
          if (!target?.available) throw new Error("This shade is unavailable. Your original selection has been kept.");
          if (target.id===old.variant_id) return;
          if (plan(old) && !target.selling_plan_allocations?.some(x=>Number(x.selling_plan_id)===Number(plan(old)))) throw new Error("This shade is unavailable for your subscription.");
          const group=bundle(old);
          const members=group?.id ? cart.items.filter(x=>{
            const b=bundle(x);
            return b?.id===group.id && b?.deal===group.deal;
          }) : [old];
          const keys=new Set(members.map(x=>x.key));
          remaining=cart.items.filter(x=>!keys.has(x.key));
          originalGroup=members.map(input);
          const replacement=members.map(x=>({...input(x),id:x.key===old.key?target.id:x.variant_id}));
          expected=[...remaining,...replacement];
          await request("cart/update.js",{updates:Object.fromEntries(members.map(x=>[x.key,0]))});
          const removed=await request("cart.js");
          if (!equal(removed.items,remaining)) throw new Error("Your cart changed during the update. Please review your selections.");
          await request("cart/add.js",{items:replacement.slice().reverse()});
          const final=await request("cart.js");
          if (!equal(final.items,expected)) throw new Error("The shade update could not be confirmed. Please review your selections.");
        } catch(error) {
          failure="We couldn't change the shade. Please try again.";
          try {
            const current=await request("cart.js");
            if (expected && equal(current.items,expected)) failure="";
            else if (originalGroup && remaining && equal(current.items,remaining)) {
              await request("cart/add.js",{items:originalGroup.slice().reverse()});
              failure="Your original shades have been restored. Please try again.";
            }
          } catch(recoveryError) {
            failure="Please review your cart before checkout. The shade update was interrupted.";
            console.error("[PinkPome shade recovery]",recoveryError);
          }
          console.error("[PinkPome shade update]",error);
        } finally {
          try { await drawer.refresh(); } catch(error) { console.error("[PinkPome cart refresh]",error); }
          controls.forEach((x,i)=>{if(x.isConnected)x.disabled=disabled[i];});
          busy=false;
          notice(failure);
        }
      },true);
      return row;
    };
    drawer.refresh().catch(console.error);
    return true;
  }
  if (!install()) {
    let attempts=0;
    const timer=setInterval(()=>{if(install() || ++attempts>=120)clearInterval(timer);},250);
  }
})();
